export default function getEssentialLocationData(locations) {
  if (!locations || !Array.isArray(locations)) return [];
  if (locations.length > 1) {
    return locations.map((loc) => ({ level: loc.level, hkey: loc.hkey }));
  }
  if (locations.hkey) {
    delete locations[0].geo;
  }    
  return locations; 
}
